<template>
  <div class="v-d-media">
    <img class="deco-img balloon-deco" src="@/assets/img/index/deco_balloon.png" />
    <div class="v-d-media__content g-content">
      <more-carousel  display link="medias" :carouselList="newsBoxList" :tabletSlidePerView="3" rounded="40" title="影音專區" :isHome="true" deco :pagination="false"/>
    </div>
  </div>
</template>
<script>
import {
  defineComponent, ref, shallowRef, watch,
} from 'vue';

import { useRoute } from 'vue-router';
import { v4 as uuid } from 'uuid';
// import PrevNextArrows from '@/components/Global/PrevNextArrows.vue';
import MediaBox from '@/components/Home/MediaBox.vue';
// import SeeMore from '@/components/Global/SeeMore.vue';
// import Carousel from '@/components/Global/Carousel.vue';
import useRequest from '@/hooks/useRequest';
import { getViewArticlesAPI } from '@/api/articles';
import previewImg from '@/assets/img/global/img_preview.jpg';
import MoreCarousel from '@/components/Global/MoreCarousel.vue';

// import mediaImg1 from '@/assets/img/index/img_1.png';
// import mediaImg2 from '@/assets/img/index/img_2.png';
// import mediaImg3 from '@/assets/img/index/img_3.png';
// import mediaImg4 from '@/assets/img/index/img_4.png';

export default defineComponent({
  name: 'Media',
  components: {
    MoreCarousel,
    // PrevNextArrows,
    // SeeMore,
    // MediaBox,
    // Carousel,
  },
  setup() {
    // const mediaBoxList = [
    //   {
    //     id: uuid(),
    //     data: {
    //       title: '北區父母成長團體，第一梯次親子按摩(0-6個月)-新竹場',
    //     },
    //     imgPath: mediaImg1,
    //     renderContent: shallowRef(MediaBox),
    //   },
    //   {
    //     id: uuid(),
    //     data: {
    //       title: '2021年8月14日守護小腳ㄚ~健康成長出遊日',
    //     },
    //     imgPath: mediaImg2,
    //     renderContent: shallowRef(MediaBox),
    //   },
    //   {
    //     id: uuid(),
    //     data: {
    //       title: '紫耀2021 只要愛你愛妳 守護小腳丫，跨出大人生',
    //     },
    //     imgPath: mediaImg3,
    //     renderContent: shallowRef(MediaBox),
    //   },
    //   {
    //     id: uuid(),
    //     data: {
    //       title: '紫耀2021 只要愛你愛妳 守護小腳丫，跨出大人生',
    //     },
    //     imgPath: mediaImg4,
    //     renderContent: shallowRef(MediaBox),
    //   },
    // ];

    // const moveOffset = ref(0);
    // const articleList = ref();
    // const itemWidth = ref();

    // const handleArrow = (action) => {
    //   console.log('handleArrow', action);
    //   if (action === 'prev') {
    //     if (moveOffset.value !== 0) {
    //       moveOffset.value -= 1;
    //     }
    //   }

    //   if (action === 'next') {
    //     if (moveOffset.value !== mediaBoxList.length - 3) {
    //       moveOffset.value += 1;
    //     }
    //   }

    //   console.log('moveOffset.value', moveOffset.value);
    // };

    // const translateOffset = computed(() => {
    //   const windowWidth = document.body.clientWidth;

    //   if (moveOffset.value === 0) return 0;

    //   if (windowWidth < 1600) {
    //     return moveOffset.value * itemWidth.value + 20;
    //   }

    //   return moveOffset.value * itemWidth.value + 70;
    // });

    // const calcItemWidth = () => {
    //   const windowWidth = document.body.clientWidth;

    //   if (windowWidth < 1024) {
    //     itemWidth.value = '100%';
    //     return;
    //   }

    //   if (windowWidth < 1600) {
    //     itemWidth.value = `${(articleList.value.clientWidth - 40) / 3}`;
    //     return;
    //   }

    //   itemWidth.value = `${(articleList.value.clientWidth - 140) / 3}`;
    // };

    // const calcItemWidthDebounce = debounce(calcItemWidth, 100);

    // onMounted(() => {
    //   calcItemWidth();
    //   window.addEventListener('resize', calcItemWidthDebounce);
    // });

    const route = useRoute();
    const newsBoxList = ref([]);

    const { response, request, isLoading } = useRequest(getViewArticlesAPI);

    request({
      page: 1,
      limit: 8,
      type: 'video',
      category: route.query.tab,
    });

    const getViewArticles = async (res) => {
      const {
        result: { data },
        status,
      } = res.value;

      if (status) {
        const baseUrl = process.env.VUE_APP_BASE_URL;

        newsBoxList.value = data.map((item) => {
          const coverImageSrc = item.cover_path ? `${baseUrl}${item.cover_path}` : previewImg;

          return {
            data: {
              title: item.title,
              desc: item.description,
              id: item.uuid,
            },
            id: uuid(),
            renderContent: shallowRef(MediaBox),
            imgPath: coverImageSrc,
          };
        });
      }
    };

    watch(response, () => {
      getViewArticles(response);
    });

    const articleList = ref();
    const itemWidth = ref();

    return {
      newsBoxList,
      articleList,
      itemWidth,
      isLoading,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '~@/styles/share/home.scss';
@import '~@/styles/utils/_rwd.scss';
.v-d-media {
  position: relative;

  &__content.g-content {
    padding-top: 50px;
    padding-bottom: 50px;
  }
}

.balloon-deco {
  @include position(bl, 0,0);
  z-index: 10;
  transform: translateY(10%);
}

.title {
  @include flex(space-between, flex-start);

}

.title-see-more {
  margin-top: 5px;
}

.article-wrap {
  width: 100%;
  overflow: hidden;
  margin-top: 40px;
}

.article-list {
  @include flex(flex-start, flex-start);
  width: 400%;
  transition: 0.4s;

  &__item {
    width: 50%;
  }
}

.tablet-show {
  display: none;
}

.see-more-wrap {
  margin-top: 30px;
}

@media screen and (min-width: $mobile) {
}

@media screen and (min-width: $portrait) {
}

@media screen and (min-width: $tablet) {
  .article-wrap {
    overflow: hidden;
  }

  .article-list {
    flex-wrap: nowrap;
    width: 100%;
    margin: 0 -10px;

    &__item {
      flex: none;
      margin: 0 10px;
    }
  }

  .title {
    @include flex(space-between);
  }

  .mobile-show {
    display: none;
  }

  .tablet-show {
    display: block;
  }
}

@media screen and (min-width: $sm-pc) {
}
@media screen and (min-width: $pc) {
  .v-d-media {
    &__content.g-content {
      padding-top: 160px;
      padding-bottom: 160px;
    }
  }

  .article-list {
    margin: 0 -35px;

    &__item {
      margin: 0 35px;
    }
  }
}
@media screen and (min-width: $lg-pc) {
}
</style>
